import { ref } from "vue";
import { defineStore } from "pinia";
import { Channel } from "@/interfaces/channel";

export const useChannelStore = defineStore("channels", () => {
    const channels = ref<Channel[]>([]);

    return {
        channels,

        getChannel(name: string) {
            return channels.value.find((state) => state.name === name);
        },

        setChannels(value: Channel[]) {
            channels.value = value;
        },
    };
});
